import { render } from "./TaxSpan.vue?vue&type=template&id=c3b1dfde"
import script from "./TaxSpan.vue?vue&type=script&lang=js"
export * from "./TaxSpan.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__